import { render, staticRenderFns } from "./Try.vue?vue&type=template&id=64ccc4c8&scoped=true"
import script from "./Try.vue?vue&type=script&lang=js"
export * from "./Try.vue?vue&type=script&lang=js"
import style0 from "./Try.vue?vue&type=style&index=0&id=64ccc4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ccc4c8",
  null
  
)

export default component.exports